<template>
  <div class="container">
      <main>
          <Search @getInputValue='getInputValue' @search='search' @add='add'>用户管理</Search>
          <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="姓名"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="position"
            label="职位"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="roleName"
            label="角色"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="tel"
            label="电话"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="lastLogin"
            label="最后登录时间"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.lastLogin | timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="100"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-edit-outline" style="fontSize:19px;color:#000"></i>
                        </el-button>
                        <el-popconfirm
                            title="确定删除吗？"
                            @confirm="confirmDelete(scope.row)"
                        >
                            <el-button type="text" slot="reference" size="mini" class="btn" >
                                <i class="el-icon-delete" style="color:red;fontSize:19px"></i>
                            </el-button>
                        </el-popconfirm>
                        <el-popconfirm
                            title="确定重置密码吗？"
                            @confirm="rePassWord(scope.row)"
                        >
                            <el-button type="text" slot="reference" size="mini" class="btn">
                                <i class="el-icon-key" style="color:red;fontSize:19px"></i>
                            </el-button>
                        </el-popconfirm>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
      </main>
      <el-dialog :title="isEdit?'编辑':'新增'" :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:60%;margin:0 auto;marginTop:-30px">
            <div class="dialogline"></div>
            <div class="dialogdiv">
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules" >
                    <el-form-item label="用户姓名" label-width="80px" prop="name">
                        <el-input v-model="dialogForm.name" autocomplete="off" placeholder="请输入用户姓名" ></el-input>
                    </el-form-item>
                    <el-form-item label="用户职位" label-width="80px" prop="position">
                        <el-input v-model="dialogForm.position" autocomplete="off" placeholder="请输入用户职位" ></el-input>
                    </el-form-item>
                    <el-form-item label="用户电话" label-width="80px" prop="tel" >
                        <el-input v-model="dialogForm.tel" autocomplete="off" placeholder="请输入用户电话" ></el-input>
                    </el-form-item>
                    <el-form-item label="用户角色" label-width="80px" prop="roleId" >
                        <el-select  v-model="jueseName" placeholder="请选择用户角色" value-key="id" @change="getjuese" style="width:100%">
                            <el-option v-for="(item,i) in jueseList" :key="i" :label="item.name"  :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="systemRole==6" label="选择网点" label-width="80px" prop="nodeId" >
                        <el-select  v-model="dialogForm.nodeId" placeholder="请选择网点">
                            <el-option v-for="(item,i) in nodeList" :key="i" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        var validatePhone = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入手机号"));
            } else if (!/^1[123456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        };
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            nodeOption: {
                filter: '',
                pageSize: 10000,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                name: '',
                position: '',
                roleId: '2',
                tel: '',
                nodeId: ''
            },
            formRules:{
                name:[{
                    required: true,
                    message: "请输入姓名",
                    trigger: "blur"
                }],
                position:[{
                    required: true,
                    message: "请输入职位",
                    trigger: "blur"
                }],
                tel:[{
                    required: true,
                    validator: validatePhone,
                    trigger: "blur"
                }],
                roleId:[{
                    required: true,
                    message: "请选择角色",
                    trigger: "blur"
                }],
                nodeId:[{
                    required: true,
                    message: "请选择网点",
                    trigger: "blur"
                }],
            },
            list: [],
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            jueseList: [],
            jueseName: '',
            systemRole: 1,
            nodeList: [],
            inputValue: '',
        }
    },
    methods:{
        //获取用户列表
        getList(option){
            this.$api.UserList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //用户获取厂商所有角色
        getGroupAllRoleList(){
            this.$api.GroupAllRoleList().then(res=>{
                this.jueseList = res.data.data.data;
                this.jueseName = this.jueseList[0].name
            })
        },
        //获取网点列表
        getPersonNodeList(option){
            this.$api.PersonNodeList(option).then(res=>{
                this.nodeList = res.data.data.data;
            })
        },
        //角色发生改变时
        getjuese(val){
            this.dialogForm.roleId = val.id;
            this.jueseName = val.name;
            this.systemRole = val.systemRole
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                name: '',
                position: '',
                roleId: 2,
                tel: '',
                nodeId: ''
            };
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: row.id,
                name: row.name,
                position: row.position,
                roleId: row.roleId,
                tel: row.tel,
                nodeId: String(row.nodeId)
            };
            this.systemRole = row.roleId;
            this.jueseName = row.roleName;
        },
        //删除
        confirmDelete(row){
            this.$api.DeleteUser({id: row.id}).then(res=>{
                if(res.data.code == 200){
                    this.$notify({
                        message: res.data.msg,
                        type: 'success'
                    })
                    this.getList(this.option);
                }else{
                    this.$notify({
                        message: res.data.msg,
                        type: 'error'
                    })
                }
            })
        },
        //重置密码
        rePassWord(row){
            this.$api.RestUser({id: row.id}).then(res=>{
                if(res.data.code == 200){
                    this.$notify({
                        message: res.data.msg,
                        type: 'success'
                    })
                }else{
                    this.$notify({
                        message: res.data.msg,
                        type: 'error'
                    })
                }
            })
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    this.dialogForm.nodeId = Number(this.dialogForm.nodeId);
                    if(this.isEdit){
                        this.$api.UpdateUser(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }else{
                        this.$api.AddUser(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }
                    this.dialogFormVisible = false;
                }else{
                    return false
                }
            })
        }
    },
    mounted(){
        this.getList(this.option);
        this.getGroupAllRoleList();
        this.getPersonNodeList(this.nodeOption);
    }
}
</script>

<style lang="scss" scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
</style>